var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},[_c('div',{staticClass:"body"},[_c('img',{attrs:{"src":_vm.kaifazhong}}),_c('p',[_vm._v("开发中,敬请期待")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }